var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VueSlickCarousel',_vm._b({ref:"slick"},'VueSlickCarousel',_vm.slickOptions,false),_vm._l((_vm.services),function(service){return _c('div',{key:service.additional_service_id,staticClass:"px-2"},[_c('AServiceCard',{attrs:{"item-service":service,"custom-class":'item-service-card'}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }